import Notifications from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import { NotificationFilterCategory } from "@/api/types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      queryParams: {
        offset: 0,
        limit: 10,
        category:
          (this.$route.query.category as NotificationFilterCategory) ||
          NotificationFilterCategory.ALL
      }
    };
  },
  computed: {
    notifications() {
      return this.$store.state.domains.notifications.notifications;
    }
  },
  beforeDestroy() {
    this.resetNotifications();
  },
  methods: {
    resetNotifications() {
      this.$store.commit("domains/notifications/resetNotifications");
    },
    handleUpdateQueryParams(queryParams) {
      this.queryParams = queryParams;
    },
    handleReadNotification(notificationId) {
      this.$store.dispatch("domains/notifications/readNotification", {
        notificationId
      });
    }
  },
  render(createElement) {
    return createElement(Notifications, {
      props: {
        notifications: this.notifications,
        queryParams: this.queryParams
      },
      on: {
        resetNotifications: this.resetNotifications,
        updateQueryParams: this.handleUpdateQueryParams,
        readNotification: this.handleReadNotification
      }
    });
  }
});
